import ReportWithoutCriteria from '../ReportWithoutCriteria';
import {
  SELF_PROMOTION_REPORT_ERROR,
  SELF_PROMOTION_REPORT_LOADING,
  SELF_PROMOTION_REPORT_SUCCESS,
} from './reportStates';

export default function SelfPromotionReport({
  generateSelfPromotionReport,
  getLatestSelfPromotionReport,
  selfPromotionReportData,
  selfPromotionReportState,
}) {
  return (
    <ReportWithoutCriteria
      name="Self Promotion Status Report"
      link={selfPromotionReportData?.link}
      currentState={selfPromotionReportState}
      stateLoading={SELF_PROMOTION_REPORT_LOADING}
      stateError={SELF_PROMOTION_REPORT_ERROR}
      stateSuccess={SELF_PROMOTION_REPORT_SUCCESS}
      getLatestFunc={getLatestSelfPromotionReport}
      generateFunc={generateSelfPromotionReport}
    />
  );
}
